var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 24.4922C18.5391 24.4922 23.9531 19.0664 23.9531 12.5391C23.9531 6 18.5273 0.585938 11.9883 0.585938C5.46094 0.585938 0.046875 6 0.046875 12.5391C0.046875 19.0664 5.47266 24.4922 12 24.4922ZM12 16.5352C8.48438 16.5352 5.76562 17.7891 4.58203 19.1953C3 17.4375 2.05078 15.1055 2.05078 12.5391C2.05078 7.00781 6.45703 2.57812 11.9883 2.57812C17.5195 2.57812 21.9492 7.00781 21.9609 12.5391C21.9727 15.1055 21.0117 17.4375 19.4297 19.207C18.2461 17.8008 15.5273 16.5352 12 16.5352ZM12 14.543C14.25 14.5664 16.0195 12.6445 16.0195 10.125C16.0195 7.75781 14.25 5.78906 12 5.78906C9.75 5.78906 7.96875 7.75781 7.98047 10.125C7.99219 12.6445 9.75 14.5195 12 14.543Z",
    fill: "#3779E1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.344027c3a4620075ec08f953c218df6f.svg";
export { ForwardRef as ReactComponent };